<app-complex-modal-template
    [canConfirm]="dataExportService.canConfirm()"
    [confirmIcon]="['fas', 'download']"
    [confirmLabel]="'export'"
    [confirmTooltip]="confirmTooltip()"
    [stepNumber]="1"
    [title]="'dataExportConfiguration' | transloco"
    (onClickEvent)="closeModal($event)">
    <div class="flex flex-col gap-4 p-6 items-center">
        <app-common-information class="w-full" />

        <app-text-toggle
            [defaultValue]="this.dataExportService.selectionMode() ? [this.dataExportService.selectionMode()!] : []"
            [options]="selectionModeOptions()"
            (selectionChange)="onExportModeChange($event)" />

        @if (!dataExportService.isGeographicZoneMode()) {
            <app-entity-selection class="w-full" />
        } @else {
            <app-geographic-zone class="w-full" />
        }
    </div>
</app-complex-modal-template>
